export {LearnerService} from '@modules/groups-management/core/services/learner.service';
export {TrainerService} from '@modules/groups-management/core/trainer/trainer.service';
export {GroupService} from '@modules/groups-management/core/services/group.service';
export {WorkgroupService} from '@modules/groups-management/core/workgroup/workgroup.service';
export {InstitutionGroupService} from '@modules/groups-management/core/services/institution-group.service';
export {GroupsManagementModule} from './core/groups-management.module';
export {GroupsManagementService} from './core/services/groups-management.service';
export {ServicesInstantiatorService as GroupsManagementServicesInstantiatorService} from './core/services/services-instantiator.service'
